import { render, staticRenderFns } from "./CreateTransferTransactionInventory.vue?vue&type=template&id=0180057e"
import script from "./CreateTransferTransactionInventory.vue?vue&type=script&lang=js"
export * from "./CreateTransferTransactionInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports